import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignHistoryItem from "../user-campaigns-history-item/component"
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {demoRegister} from "../../services/demoRegister";
import {marketRegister} from "../../services/marketRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import ModalNotificationsLanguage from "../modal-notificationslanguage/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class userSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: "engelska",
            ref_lang: "",
            isLoading: true,
            edit: false,
            error: false,
            lang_modal: false
        };
        this._setLang = this._setLang.bind(this);
    };

    componentWillMount() {
        this._updateLang();
        this._updateLanguages();
    }

    _signOut(){
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +"/login");
    }

    _updateLang(){
        dataRegister.getAccount(salesChannelRegister.get("market")).then((response) => {
            if(response.lang){
                this.setState({lang: response.lang, isLoading: false});
            }
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get("languages"));
        this.setState({languages: languages});
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[lang];
            }
        }
        return value;
    }

    _setLang(lang) {
        if(lang){
            if(this.state.ref_lang !== this.state.lang){
                this.setState({isLoading: true, lang_modal: false});
                dataRegister.postAccount(salesChannelRegister.get("market"), {lang: this.state.ref_lang}).then((response) => {
                    if(response.lang){
                        this.setState({isLoading: false, error: false, edit: false, lang: response.lang});
                    }else{
                        this.setState({isLoading: false, error: true, edit: false});
                    }
                }, (error) => {
                    this.setState({isLoading: false, error: true, edit: false});
                });
            }
        }else{
            this.setState({lang_modal: false});
        }
    }

    _renderText(item) {
        return langRegister.get("user-settings", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.lang_modal &&
                    <ModalNotificationsLanguage lang={this.state.ref_lang} setLang={this._setLang} props={this.props}/>
                }
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_2")}
                                    </div>
                                    <div onClick={() => this.setState({edit: !this.state.edit})} className={
                                        cx(Styles.contentInnerItemHeaderEdit,
                                            {
                                                [Styles.contentInnerItemHeaderEditActive]: this.state.edit
                                            })
                                    }>
                                        {!this.state.edit && this._renderText("item_3")}
                                        {this.state.edit && this._renderText("item_6")}
                                    </div>
                                    {
                                        !this.state.edit &&
                                        <div onClick={() => this.setState({edit: true})} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit &&
                                        <div className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={
                                            cx(Styles.dropdown,
                                                {
                                                    [Styles.dropdownDisabled]: !this.state.edit,
                                                })
                                        }>
                                            <select disabled={!this.state.edit} className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this.setState({ref_lang: event.target.value, lang_modal: true})}>
                                                {
                                                    this.state.languages.map((item) => {
                                                        return(
                                                            <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <div className={Styles.dropdownText}>
                                                {this._renderLanguage(this.state.lang)}
                                            </div>
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userSettings;


// WEBPACK FOOTER //
// ./src/components/user-settings/component.js